<template>
  <div class="mb-header-container-2">
    <div class="header_head header-bottom mb_header_fixed">
      <div class="zip_container" v-if="shippingMethodGlobal === 'Delivery'">
        <div class="white" @click="toggleShippingMethodModalVisibility_mobile(true)">
          <img src="../../assets/img/pin.svg"/>
<!--          <p class="white_txt home-10px" v-if="userZip">{{ $t('delivery_to') }} {{ userZip }}</p>-->
<!--          <p class="white_txt home-10px" v-if="!userZip">{{ $t('delivery_to') }} {{ $t('enter_zip_code') }}</p>-->
<!--          <div>-->
<!--            <i class="fa fa-caret-down" style="margin-left: 10px" aria-hidden="true"></i>-->
<!--          </div>-->
        </div>
      </div>

      <div class="zip_container" v-if="shippingMethodGlobal === 'Pickup'">
        <div class="white" @click="toggleShippingMethodModalVisibility_mobile(true)">
          <img src="../../assets/img/pin.svg"/>
<!--          <p class="white_txt home-10px" v-if="this.warehouseLocation && this.warehouseLocation !== 'All'">-->
<!--            {{ $t('pick_up_from') }} {{ this.warehouseLocation }}</p>-->
<!--          <p class="white_txt home-10px"  v-else>{{ $t('pick_up_from') }} {{ $t('select_store') }}</p>-->
<!--          <div>-->
<!--            <i class="fa fa-caret-down" style="margin-left: 10px" aria-hidden="true"></i>-->
<!--          </div>-->
        </div>
      </div>

      <div class="search-bar"  @click="$router.push({path:'/mobileSearch'})">
        <input
          type="text"
          :placeholder="$t('search_for')"
        >
        <div class="search hoverBtn">
          <font-awesome-icon icon="search" :style="{ color: 'white', fontSize: '12px' }"/>
        </div>
      </div>

      <a class="lang" @click="langChanged">
        <img class="mb-home-lang-img" src="../../assets/img/earth.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import {locales} from '../../mixin'

export default {
  name: "mbHeader2",
  mixins: [locales],
  computed: {
    ...mapState({
      shippingMethodGlobal: state => state.navbar.shippingMethodGlobal,
      userZip: state => state.navbar.userZip,
      warehouseLocation: state => state.navbar.warehouseLocation,
    })
  },
  methods: {
    ...mapMutations('navbar', ['toggleShippingMethodModalVisibility_mobile'])
  }
}
</script>

<style lang="less">
.mb-header-container-2 {
  .zip_container {
    flex: none !important;
  }
  .lang {
    margin: 0 !important;

    .mb-home-lang-img {
      height: 16px;
    }
  }

  .search-bar {
    width: 200px;
    position: relative;
    margin: 0 20px;
    flex: 1;

    input {
      width: 100%;
      height: 30px;
      background: #ffffff;
      border-radius: 15px;
      border: none;
      font-size: 12px;
      font-weight: bold;
      box-shadow: none;
      padding: 2px 10px 0;
      outline: none;
    }

    ::placeholder {
      color: #E9C34B;
    }

    .hoverBtn {
      height: 22px;
      width: 22px;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      background-color: #E9C34B;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mbHeader2.vue